// Globals
import { useTranslation } from 'react-i18next';

// Components
import { IFormInstance } from '@/components';
import { TextArea } from '@/ui';
import { StyledForm, StyledFormItem } from './LLMTemplateContentFormStyles';

// Helpers
import { LLMTemplateFormFields, TLLMTemplateFormValues } from '../../helpers';

interface ILLMTemplateContentFormProps {
  form: IFormInstance;
  initialValues?: TLLMTemplateFormValues;
  onSubmit: (values: TLLMTemplateFormValues) => void;
}

const LLMTemplateContentForm = ({ form, initialValues, onSubmit }: ILLMTemplateContentFormProps) => {
  const { t } = useTranslation();

  return (
    <StyledForm form={form} initialValues={initialValues} onFinish={onSubmit}>
      <StyledFormItem name={LLMTemplateFormFields.CONTENT} label={t('llm_template_content_label')}>
        <TextArea />
      </StyledFormItem>
    </StyledForm>
  );
};

export default LLMTemplateContentForm;
